// Painel: números do suporte (por tratar, prazos, sem responsável, tempo médio da 1.ª resposta).
import { useApi } from "@ecliptica/api-client/react";
import { useTranslation } from "@ecliptica/i18n";
import { Card, CardContent, CardHeader, CardTitle } from "@ecliptica/ui";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";

export function SupportStats() {
  const { t } = useTranslation();
  const api = useApi();
  const q = useQuery({
    queryKey: ["support-stats"],
    queryFn: async () => (await api.v1.admin.support.stats.$get()).json(),
    refetchInterval: 60_000,
  });
  const s = q.data;
  const cells: [string, string | number, string, string?][] = s
    ? [
        ["active", s.active, "/support"],
        ["atRisk", s.atRisk, "/support?sort=sla", s.atRisk ? "text-warning" : undefined],
        ["breached", s.breached, "/support?sort=sla", s.breached ? "text-destructive" : undefined],
        ["unassigned", s.unassigned, "/support?assignee=none"],
      ]
    : [];
  return (
    <Card className="sm:col-span-2 xl:col-span-3">
      <CardHeader>
        <CardTitle>{t("desk.stats.title")}</CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-2 gap-3 sm:grid-cols-5">
        {cells.map(([k, v, to, cls]) => (
          <Link key={k} to={to} className="rounded-md border p-3 hover:border-gold/60">
            <p className={`text-2xl font-extrabold ${cls ?? ""}`}>{v}</p>
            <p className="text-xs text-muted-foreground">{t(`desk.stats.${k}`)}</p>
          </Link>
        ))}
        {s && (
          <div className="rounded-md border p-3">
            <p className="text-2xl font-extrabold">{s.avgFirstResponseHours === null ? t("desk.stats.na") : t("desk.stats.hours", { h: s.avgFirstResponseHours.toFixed(1) })}</p>
            <p className="text-xs text-muted-foreground">{t("desk.stats.avgFirst")}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
